import PropTypes from 'prop-types'

import { ROUTE_REWARDS, ROUTE_REWARDS_MY_REWARDS } from '@/routes/paths'
import useGetRewardBalance from '../hooks/use-get-reward-balance'
import { useNavigate } from 'react-router-dom'
import RewardsSkeleton from './rewards.skeleton'
import { ChevronRight } from 'lucide-react'
import { SpendingProgressBar } from '@/components'

const Rewards = () => {
  const navigate = useNavigate()

  const { isLoading, data: rewardsData } = useGetRewardBalance('quarter')

  if (isLoading) {
    return <RewardsSkeleton />
  }
  return (
    <div className="w-full md:mt-6">
      <button
        className="flex flex-row items-center justify-between w-full"
        onClick={() => navigate(`/${ROUTE_REWARDS}${ROUTE_REWARDS_MY_REWARDS}`)}
      >
        <p className="text-base font-semibold text-neutral-700">Points Balance</p>
        <div className="flex flex-row items-center gap-1">
          <p className="text-2xl font-semibold text-neutral-900">
            {Number(rewardsData?.pointsBalance || 0).toLocaleString()}
          </p>
          <ChevronRight height={24} />
        </div>
      </button>
      <div className="border-b-dGray-200 border-b-[1px] my-6 hidden md:block" />
      <div className="hidden md:block">
        <SpendingProgressBar className="mt-6" />
      </div>
    </div>
  )
}

Rewards.prototype = {
  data: PropTypes.object,
}

export default Rewards
